module.exports = __webpack_public_path__ + "static/media/LOVES_CAR_RIDES.a4eef9f8.svg";